import { render, staticRenderFns } from "./PlacementsEndComponentReviewGraduateComments.vue?vue&type=template&id=9b684188&"
import script from "./PlacementsEndComponentReviewGraduateComments.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponentReviewGraduateComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports